import {
  jb_multi_checkbox_css_default
} from "./chunk.OBAL6YXZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r2,
  r2 as r3
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-multi-checkbox/jb-multi-checkbox.ts
var JbMultiCheckbox = class extends Initiable(r) {
  constructor() {
    super(...arguments);
    this.minimumChecks = 0;
    this.showError = false;
  }
  appendFormData(formDataEvent) {
    const values = [...this._checkboxes].filter((el) => el.isChecked()).map((el) => el.value);
    values.forEach((value) => formDataEvent.formData.append(this.name + "[]", value));
  }
  validate() {
    const checkedAmount = [...this._checkboxes].filter((el) => el.isChecked()).length;
    const valid = checkedAmount >= this.minimumChecks;
    this.showError = !valid;
    return valid;
  }
  render() {
    return ke`
      <div>
        <p>${this.label}${this.minimumChecks > 0 ? "*" : ""}</p>
        ${this.options.map(
      (option) => ke`
            <jb-checkbox
              value="${option.value}"
              label="${option.label}"
            ></jb-checkbox>
          `
    )}
        ${this.showError ? ke`<p class="error">${this.requiredText}</p>` : D}
      </div>
    `;
  }
};
JbMultiCheckbox.styles = jb_multi_checkbox_css_default;
__decorateClass([
  n()
], JbMultiCheckbox.prototype, "label", 2);
__decorateClass([
  n({ type: Number })
], JbMultiCheckbox.prototype, "minimumChecks", 2);
__decorateClass([
  n()
], JbMultiCheckbox.prototype, "name", 2);
__decorateClass([
  n({ type: Array })
], JbMultiCheckbox.prototype, "options", 2);
__decorateClass([
  n()
], JbMultiCheckbox.prototype, "requiredText", 2);
__decorateClass([
  r2()
], JbMultiCheckbox.prototype, "showError", 2);
__decorateClass([
  r3("jb-checkbox")
], JbMultiCheckbox.prototype, "_checkboxes", 2);
JbMultiCheckbox = __decorateClass([
  customElement("jb-multi-checkbox")
], JbMultiCheckbox);

export {
  JbMultiCheckbox
};
